import {createContext, useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../services/firebaseConnection";


export const AuthContext = createContext()

function AuthProvider({ children }) {

    const [user, setUser] = useState(null);
    const [userFirebase, setUserFirebase] = useState(null);
    const [loadingAuth, setLoadingAuth] = useState(true);

    useEffect(() => {
        const userStorage = localStorage.getItem("@userFirebase");
        if (userStorage) {
            setUserFirebase(JSON.parse(userStorage));
        }
  }, []);

    useEffect(()=>{
        const unsub = onAuthStateChanged(auth, (user)=>{
            if(user){
                setUser({
                    uid: user.uid,
                    name: user.displayName,
                    email: user.email
                })

                setLoadingAuth(false);
            }else{
                setUser(null);
                setLoadingAuth(false);
            }
        })

        return() => {
            unsub();
        }
    }, [])


    function handleInfoUser({name, email, uid}){
        setUser({
            name,
            email,
            uid
        })
    }


    return(
        <AuthContext.Provider 
            value={{
                signed: !!user,
                loadingAuth,
                handleInfoUser,
                user,
                userFirebase, 
                setUserFirebase
            }}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthProvider;
